export enum ReferralPatientSituation {    
    HasNoDonor = 1,
    HasDonor = 2,
    HasCompatibleDonor = 3,
    HasIncompatibleDonor = 4
}